import { Tier, tierWeight } from './chunk-MY2WTNZQ.js';

// src/labels/index.ts
var SCOPE_TIER = {
  user: Tier.USER_OVERRIDE,
  tenant: Tier.CUSTOMER_OVERRIDE,
  org: Tier.ORG_OVERRIDE,
  default: Tier.DEFAULT,
  entity: Tier.ENTITY_INHERITED,
  provider: Tier.PROVIDER_CANDIDATE
};
function scopeWeight(scope) {
  return tierWeight(SCOPE_TIER[scope]);
}
var RESOLUTION_ORDER = Object.keys(SCOPE_TIER).sort((a, b) => scopeWeight(b) - scopeWeight(a));
function resolveScalar(layers) {
  for (const scope of RESOLUTION_ORDER) {
    const v = layers[scope];
    if (v != null) return v;
  }
  return void 0;
}
var resolveLabel = resolveScalar;
function mergeLabels(labels) {
  const winners = /* @__PURE__ */ new Map();
  for (const label of labels) {
    const existing = winners.get(label.key);
    if (!existing || scopeWeight(label.scope) > scopeWeight(existing.scope)) {
      winners.set(label.key, label);
    }
  }
  const out = /* @__PURE__ */ new Map();
  for (const [key, label] of winners) {
    if (!label.suppressed) out.set(key, label.value);
  }
  return out;
}
function mergeTags(layers) {
  const ci = layers.caseInsensitive ?? true;
  const norm = (t) => ci ? t.trim().toLowerCase() : t.trim();
  const removed = /* @__PURE__ */ new Set();
  for (const t of layers.remove ?? []) removed.add(norm(t));
  const seen = /* @__PURE__ */ new Set();
  const out = [];
  for (const layer of [layers.user, layers.tenant, layers.org, layers.default]) {
    for (const raw of layer ?? []) {
      const key = norm(raw);
      if (!key || removed.has(key) || seen.has(key)) continue;
      seen.add(key);
      out.push(ci ? key : raw.trim());
    }
  }
  return out;
}

export { SCOPE_TIER, mergeLabels, mergeTags, resolveLabel, resolveScalar, scopeWeight };
//# sourceMappingURL=chunk-ZLFQI3AD.js.map
//# sourceMappingURL=chunk-ZLFQI3AD.js.map